const Footer = () => {
  return (
    <div className="dock">
      <a
        href="https://www.linkedin.com/in/saad-kardoudi-2115861b8/"
        className="app"
        tabIndex="0"
        draggable="true"
      >
        <img
          src="https://icon-library.com/images/official-linkedin-icon-png/official-linkedin-icon-png-16.jpg"
          alt=""
        />
      </a>
      <a
        href="https://github.com/Saad-kardoudi"
        className="app"
        tabIndex="0"
        draggable="true"
      >
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWh6vSZghBVcvAzykjB2p4qUrtLu6UuwJH1UXYsHQDi-ulBu4bJoxkbqeXVdquvnza1YuGp05NVvw&usqp=CAU"
          alt=""
        />
      </a>
      <a
        href="https://www.pinterest.com/SaadDarell/"
        className="app"
        tabIndex="0"
        draggable="true"
      >
        <img
          src="https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F23%2F2012%2F09%2F13%2Fpinterest-logo_300.jpg&q=85"
          alt=""
        />
      </a>
    </div>
  );
};

export default Footer;
